import { render, staticRenderFns } from "./formTiktok.vue?vue&type=template&id=d616b3ba"
import script from "./formTiktok.vue?vue&type=script&lang=js"
export * from "./formTiktok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d616b3ba')) {
      api.createRecord('d616b3ba', component.options)
    } else {
      api.reload('d616b3ba', component.options)
    }
    module.hot.accept("./formTiktok.vue?vue&type=template&id=d616b3ba", function () {
      api.rerender('d616b3ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/formNetwork/formTiktok.vue"
export default component.exports